import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { PaymentMethodGetDto } from "../dto";

@Injectable({
  providedIn: "root"
})
export class PaymentService {
  private serviceUrl = "Payment";

  constructor(private api: ApiService) {}

  getPaymentMethodStatus(includePaymentIntent: boolean): Observable<PaymentMethodGetDto> {
    return this.api.get(`${this.serviceUrl}/chargebee/payment-method?includePaymentIntent=${includePaymentIntent}`);
  }

  updatePaymentMethod(paymentIntentId: string): Observable<void> {
    return this.api.post(`${this.serviceUrl}/chargebee/payment-method`, { paymentIntentId });
  }

  deletePaymentMethod(): Observable<void> {
    return this.api.delete(`${this.serviceUrl}/chargebee/payment-method`);
  }
}
